import { MoneyDisplay } from './MoneyDisplay';
import { cn } from '../../utils/cn';

/**
 * Cartão KPI compacto (rótulo à esquerda, valor à direita).
 */
export function SlimMetricCard({
  label,
  value,
  hint,
  isMoney = true,
  highlight = false,
  suffix = null,
  trailing = null,
  loading = false,
  className,
}) {
  return (
    <div
      data-ds-id="ds/card/stat-tiles--slim"
      className={cn(
        // eslint-disable-next-line no-restricted-syntax -- altura mínima do cartão
        'box-border flex w-full min-h-[2.75rem] min-w-0 items-center justify-between gap-3 rounded-ds-md border px-3 py-2 md:min-h-[3rem] md:px-4 md:py-2.5',
        highlight
          ? 'border-sage-300 bg-sage-100 dark:border-sage-700 dark:bg-sage-900/50'
          : 'border-border bg-card',
        loading && 'opacity-60',
        className,
      )}
      aria-busy={loading || undefined}
    >
      <div className="min-w-0 flex-1">
        <p
          className={cn(
            'text-xs font-medium md:text-sm',
            highlight
              ? 'text-sage-800 dark:text-sage-200'
              : 'text-muted-foreground',
          )}
        >
          {label}
        </p>
        {hint ? (
          <p className="type-caption truncate text-muted-foreground/70 md:text-xs" title={hint}>
            {hint}
          </p>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <div className="flex shrink-0 items-baseline gap-1.5">
          {isMoney ? (
            <MoneyDisplay
              value={value}
              size="md"
              className={cn(
                'font-semibold',
                highlight ? 'text-sage-900 dark:text-sage-100' : 'text-foreground',
              )}
            />
          ) : (
            <span className={cn(
              'tnum text-lg font-semibold',
              highlight ? 'text-sage-900 dark:text-sage-100' : 'text-foreground',
            )}>{value}</span>
          )}
          {suffix}
        </div>
        {trailing}
      </div>
    </div>
  );
}
